import { ChartColumn } from '@gravity-ui/icons'
import { CardTitle, Spinner } from '@heroui/react'
import { useTranslation } from 'react-i18next'

import { Card, CardContent, CardHeader } from '@/components/ui/Card'
import { EmptyState } from '@/components/ui/EmptyState'
import { useAnalyticsStore } from '@/store/analytics.store'

import { AnalyticsBarChart } from './AnalyticsBarChart'
import { AnalyticsDonutChart } from './AnalyticsDonutChart'
import { AnalyticsExpenseList } from './AnalyticsExpenseList'
import { AnalyticsHeatmap } from './AnalyticsHeatmap'
import { AnalyticsMetrics } from './AnalyticsMetrics'

export function AnalyticsDisplay() {
  const { t } = useTranslation()
  const { isLoading, filters } = useAnalyticsStore()

  if (!filters.driverID || !filters.from || !filters.to) {
    return (
      <EmptyState
        icon={<ChartColumn className="size-8" />}
        title={t('analytics.empty_state_title', 'No Data Selected')}
        description={t('analytics.empty_state', 'Please select a driver and a date period to view analytics.')}
      />
    )
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64 border border-dashed rounded-xl border-white/10">
        <Spinner size="lg" color={'current'} />
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <AnalyticsMetrics />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:h-[480px]">
        <Card className="flex flex-col h-full">
          <CardHeader className="shrink-0">
            <CardTitle>{t('analytics.heatmap', 'Expense Activity Heatmap')}</CardTitle>
          </CardHeader>
          <CardContent className="flex-1 min-h-0">
            <AnalyticsHeatmap />
          </CardContent>
        </Card>

        <div className="h-full min-h-0">
          <AnalyticsExpenseList />
        </div>
      </div>
      
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="flex flex-col min-h-[400px]">
          <CardHeader className="shrink-0">
            <CardTitle>{t('analytics.expenses_by_type', 'Expenses by Type')}</CardTitle>
          </CardHeader>
          <CardContent className="flex-1">
            <AnalyticsBarChart />
          </CardContent>
        </Card>

        <Card className="flex flex-col min-h-[400px]">
          <CardHeader className="shrink-0">
            <CardTitle>{t('analytics.expenses_by_country', 'Expenses by Country')}</CardTitle>
          </CardHeader>
          <CardContent className="flex-1">
            <AnalyticsDonutChart />
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
